/** Memoized task buckets for daily section views. */
import { useMemo } from 'react';
import {
  getDayBoundaries,
  getOverdueTasks,
  getTodayTasks,
  getCompletedTodayTasks,
  getUpcomingTasks,
} from '@/features/tasks/utils/views/dailySectionsUtils';

export function useDailySectionBuckets(filteredTasks, tasksMap) {
  const overdueTasks = useMemo(() => {
    const { startOfToday } = getDayBoundaries();
    return getOverdueTasks(filteredTasks, startOfToday, tasksMap);
  }, [filteredTasks, tasksMap]);

  const todayTasks = useMemo(() => {
    const { startOfToday, endOfToday } = getDayBoundaries();
    return getTodayTasks(filteredTasks, startOfToday, endOfToday, tasksMap);
  }, [filteredTasks, tasksMap]);

  const completedTodayTasks = useMemo(() => {
    const { startOfToday, endOfToday } = getDayBoundaries();
    return getCompletedTodayTasks(filteredTasks, startOfToday, endOfToday);
  }, [filteredTasks]);

  const upcomingTasks = useMemo(() => {
    const { endOfToday } = getDayBoundaries();
    return getUpcomingTasks(filteredTasks, endOfToday);
  }, [filteredTasks]);

  return { overdueTasks, todayTasks, completedTodayTasks, upcomingTasks };
}
